import * as Yup from 'yup';
import { getLocationsFromZip } from '../utils';
import memoize from 'lodash.memoize';

const emptyZipError = 'Please enter your zip\u00A0code.';
const invalidZipError = 'Please enter a valid zip\u00A0code.';
const maxCharZipError = 'Please enter five characters for your zip\u00A0code.';
const getLocations = memoize(getLocationsFromZip);

const zipSchema = Yup.object().shape({
  postal_code: Yup.string()
    .trim()
    .required(emptyZipError)
    .max(5, maxCharZipError)
    .matches(/^\d{5}$/, invalidZipError)
    .test('test-zip', invalidZipError, async (value: string) => {
      if (!value) {
        return true;
      }

      try {
        const data = await getLocations(value);

        return data.length > 0;
      } catch {
        console.error(`Error while fetching locations for zip code: ${value}`);
        return true;
      }
    })
});

export { zipSchema };
